const footerLinks = {
  热门栏目: ['焦点专题', '爆料视频', '实时快讯', '热度榜单', '图文资讯', '用户反馈'],
  内容分类: ['明星绯闻', '网红内幕', '实锤吃瓜', '社会事件', '最新爆料', '独家深挖'],
  关于我们: ['平台介绍', '投稿指南', '隐私保护', '免责声明', '联系方式', '加入我们'],
};

export default function Footer() {
  return (
    <footer id="footer" className="relative bg-background-50 border-t border-background-200/30">
      <div className="max-w-6xl mx-auto px-4 md:px-8 pt-16 md:pt-20 pb-8">
        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          <div className="md:w-[38%]">
            <a href="#hero" className="inline-flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-flashlight-fill text-background-950 text-sm"></i>
              </span>
              <span className="text-foreground-50 font-bold text-lg tracking-tight whitespace-nowrap">51爆料网</span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-xs">
              全网热门吃瓜资讯与黑料视频合集。每日追踪娱乐圈最新动态，深度挖掘明星黑料与网红内幕，让吃瓜群众第一时间掌握最新资讯。
            </p>
          </div>

          <div className="md:w-[62%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category}>
                <h4 className="text-sm font-semibold text-foreground-200 mb-4 whitespace-nowrap">{category}</h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href={`#${link}`}
                        className="text-xs text-foreground-600 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/30">
          <h4 className="text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 mb-8">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="h-12 rounded-lg bg-background-100 border border-background-200/50 flex items-center justify-center"
              >
                <span className="text-[10px] text-foreground-700">虚位以待</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-700">
              &copy; 2026 51爆料网. 本站内容仅供娱乐参考，不构成任何投资或法律建议。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-600">
              <a href="#faq" className="hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#faq" className="hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
              <a href="#contact" className="hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}